import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import blogdata from '../../data/blogdata.json'
import useFetch from '../../Hooks/useFetch'
import { saveAs } from 'file-saver'
import { useLocation } from 'react-router-dom'
import { Button } from 'react-bootstrap'

function PostList(props) {
  const location = useLocation()
  console.log(location.pathname)

  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  let datas = props.posts
  return (
    <div>
      <div className='property-news-area pd-top-100 pd-bottom-70'>
        <div className='container '>
          <div className='row'>
            {datas?.map((item, i) => (
              <div key={i} className='col-lg-6' style={{ display: 'flex' }}>
                <div style={{ width: '100%' }} className='single-news'>
                  <div
                    className='thumb'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={item.image} height='300' alt={imagealt} />
                  </div>
                  <div className='details'>
                    <h4>
                      <Link to={item.url}>{item.title}</Link>
                    </h4>
                    {location.pathname === '/maps' ? (
                      <Button
                        variant='primary'
                        onClick={() => saveAs(item.image, 'map.jpg')}
                      >
                        Download
                      </Button>
                    ) : (
                      <Button
                        variant='primary'
                        onClick={() => saveAs(item.image, 'blogs.jpg')}
                      >
                        Download
                      </Button>
                    )}
                    <p>{item.content}</p>
                    {!props.map && ( //not understandable
                      <div className='author'>
                        <img src={item.authorImg} alt={imagealt} />
                        <span>By {item.author}</span>
                        <span className='date'>{item.date}</span>
                      </div>
                    )}{' '}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PostList
